import './index.less';
import { useEffect, useState, useRef, useContext } from 'react';
import { ContextMenu } from 'bimui';
import { ReactComponent as HeadSvg } from './icons/head.svg';
import { ReactComponent as PopSvg } from './icons/pop-button.svg';
import { ReactComponent as AreaSvg } from './icons/area.svg';
import { ReactComponent as TimeSvg } from './icons/time.svg';
import { ReactComponent as PointSvg } from './icons/point.svg';
import SearchMenu, { Category } from './search-menu';
import { useParams } from 'react-router-dom';
import { queryDboxs, queryMobjects, querySensors } from '@/declare/api/monix';
import axios from 'axios';
import { MonitorObjectType } from '@/declare/enums/monitor-object-type';
import { SystemContext } from '@/App';

interface IProps {

}

export default function ScreenHeader(props: IProps) {
    const { monixProjectId, bimProjectId, bimModelUuid } = useParams(); // 路由参数
    const systemContext = useContext(SystemContext);
    const [weatherC, setWeatherC] = useState<string>(''); // 用于保存天气描述信息
    const [weatherT, setWeatherT] = useState<string>(''); // 用于保存天气温度数据
    const [currentDate, setCurrentDate] = useState<string>(''); // 用于保存当前日期（YYYY-MM-DD）
    const [currentDay, setCurrentDay] = useState<string>(''); // 用于保存当前星期几
    const [currentTime, setCurrentTime] = useState<string>(new Date().toLocaleTimeString()); // 用于保存时间
    const [categories, setCategories] = useState<any[]>([]);
    const [cmOpen, setCmOpen] = useState<boolean>(false);// 是否激活监测对象的搜索列表弹窗
    const [cmTop, setCmTop] = useState<number>(); // 监测对象搜索列表弹窗top
    const [cmLeft, setCmLeft] = useState<number>(); // 监测对象搜索列表弹窗left



    useEffect(() => {
        // 获取监测对象数据
        generateData();
        // 获取天气数据
        fetchWeatherData();

        // 每秒更新时间
        const intervalId = setInterval(() => {
            setCurrentTime(new Date().toLocaleTimeString()); // 更新当前时间
        }, 1000);

        // 更新当前日期和星期几
        const date = new Date();
        const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
        setCurrentDate(formattedDate);
        setCurrentDay(date.toLocaleString('zh-CN', { weekday: 'long' })); // 获取星期几，中文形式

        // 设置一个定时器，15秒后重新获取天气数据
        const timeoutId = setTimeout(() => {
            if (!weatherC || !weatherT) {
                fetchWeatherData(); // 如果 weatherC 或 weatherT 为空，则重新获取天气数据
            }
        }, 60000); // 15秒后执行

        // 清除定时器和更新时间的定时器
        return () => {
            clearInterval(intervalId);
            clearTimeout(timeoutId); // 清除 15秒的定时器
        };

    }, [weatherC, weatherT]); // 只在组件挂载时执行一次

    /**
     * 获取天气信息的方法
     */
    const fetchWeatherData = async () => {
        try {
            // 请求 wttr.in 获取上海的天气数据
            const response = await fetch('https://wttr.in/shanghai?format=%C+%t'); // 返回格式为 "晴 16~20°C"
            const data = await response.text();

            // 根据格式分离描述和温度
            const [description, temperature] = data.split(' ');
            setWeatherC(description); // 设置天气描述
            setWeatherT(temperature); // 设置温度数据
        } catch (error) {
            console.error('获取天气数据失败:', error);
        }
    };

    const popButtonRef = useRef<HTMLDivElement>(null); // 右侧按钮的 ref
    // 计算按钮的左上角坐标，展示菜单
    const handleButtonClick = () => {
        if (popButtonRef.current) {
            const buttonRect = popButtonRef.current.getBoundingClientRect();
            console.log(buttonRect.right) // 获取 screen-header-model 元素的位置信息
            setCmLeft(buttonRect.right - 173); // 弹窗左侧与按钮右侧平齐
            setCmTop(buttonRect.bottom + 10); // 弹窗顶部距离按钮 10px
        }
        setCmOpen(true); // 打开弹窗
    };


    const generateData = () => {
        // TODO 获取监测对象、传感器和采集箱
        let queryMobjectsPromise = queryMobjects({ project_id: monixProjectId })
        // let queryDboxsPromise = queryDboxs({ project_id: monixProjectId })
        // let querySensorsPromise = querySensors({ project_id: monixProjectId })
        // axios.all([queryMobjectsPromise, queryDboxsPromise, querySensorsPromise]).then(res => {
        axios.all([queryMobjectsPromise]).then(res => {
            let mobjects = res[0].data || [];
            console.log('mobjects', mobjects)
            // let dboxs = res[1].data || [];
            // let sensors = res[2].data || [];
            // // setSensors(sensors);
            // // setDboxs(dboxs);
            let category: Category[] = [];

            let comArr = [];
            let strucArr = [];
            let envArr = [];
            mobjects?.forEach(mo => {
                if (mo.type === MonitorObjectType.COMPONENT) {
                    comArr.push(mo);
                } else if (mo.type === MonitorObjectType.STRUCTURE) {
                    strucArr.push(mo);
                } else if (mo.type === MonitorObjectType.ENVIRONMENT) {
                    envArr.push(mo);
                }
            })
            category.push({
                name: '构件',
                items: comArr
            })
            category.push({
                name: '结构',
                items: strucArr
            })
            category.push({
                name: '环境',
                items: envArr
            })
            category.push({
                name: '设备',
                items: []
            })
            setCategories(category);
        })

    }

    return (
        <div className='screen-header-container'>
            <div className='screen-header-left'>
                <HeadSvg className="icon" />
            </div>

            <div className='screen-header-right'>
                <div className='weather-temperature-time'>
                    <div className='weather'>
                        {weatherC || '加载中...'} {/* 显示天气描述 */}
                        <PointSvg />
                        {weatherT || '加载中...'} {/* 显示温度 */}
                    </div>
                    <div className='temperature'>
                        <div className='temperature-icon'>
                            <TimeSvg />
                        </div>
                        <div className='temperature-data'>
                            {currentDate} {/* 显示当前日期 */}
                            <PointSvg />
                            {currentDay} {/* 显示当前星期几 */}
                        </div>
                    </div>
                    <div className='time'>
                        {currentTime} {/* 显示当前时间 */}
                    </div>
                </div>
                <div className='screen-header-area'>
                    <AreaSvg />
                    <div className='area-text'>
                        上海市
                    </div>
                </div>
                <div className='screen-header-model'
                    onClick={handleButtonClick} // 点击按钮时触发弹窗显示
                    ref={popButtonRef}>
                    <PopSvg />
                </div>
            </div>



            <ContextMenu
                visible={cmOpen} // 是否显示
                top={cmTop} // 菜单纵坐标
                left={cmLeft} // 菜单横坐标
                wrapperClassname='screen-header-search-menu' // 自定义右键菜单样式
                onCancel={() => {
                    setCmOpen(false); // 关闭右键菜单
                }}
            >
                {/* 引入 MenuContent 组件 */}
                <SearchMenu
                    onItemClick={() => {
                    }}
                    categories={categories}
                />

            </ContextMenu>
        </div>
    );
}